/**
 * Shared payment polling configuration
 * 
 * Used by bank transfer and USSD payment components
 * to check payment confirmation status.
 */

export const PAYMENT_POLL_INTERVAL_MS = 2000; // Poll every 2 seconds
export const PAYMENT_POLL_MAX_DURATION_MS = 120000; // Maximum 2 minutes (120 seconds)
